import Router from "./services/RouteService";

function App() {
  return (
    <Router />
  );
};

export default App;
